export default __webpack_public_path__ + "static/media/add-circle.e379419e.svg";